import { defineMessage } from 'react-intl';

export const XYCHART_MESSAGES = {
  separatorDash: defineMessage({
    id: 'sI/bFgg4u46KiHYZ',
    defaultMessage: '–',
    description:
      'Text in between the from/to value displayed in the tooltip for the xy chart rect series',
  }),
  zoomModeExplore: defineMessage({
    id: 'Siq71+wvTgBerJXL',
    defaultMessage: 'Explore mode',
    description:
      'Text in a tooltip shown when hovering the "Explore" mode in the chart toolbar',
  }),
  zoomModePan: defineMessage({
    id: 'wjx6xe/Gmj4hLt7b',
    defaultMessage: 'Pan mode',
    description:
      'Text in a tooltip shown when hovering the "Pan" mode in the chart toolbar',
  }),
  zoomModeZoom: defineMessage({
    id: 'JNqvsQ757QGyZ+wN',
    defaultMessage: 'Zoom mode',
    description:
      'Text in a tooltip shown when hovering the "Zoom" mode in the chart toolbar',
  }),
  downloadAsCsv: defineMessage({
    id: 'B1od+sZZT/rP8Plf',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the chart toolbar',
  }),
  zoomIn: defineMessage({
    id: 'mscZH1VbXmfXn9BL',
    defaultMessage: 'Zoom in',
    description:
      'Text in a tooltip shown when hovering the "Zoom in" action in the xy chart toolbar',
  }),
  zoomOut: defineMessage({
    id: 'IjB05bsdexXUZ1sw',
    defaultMessage: 'Zoom out',
    description:
      'Text in a tooltip shown when hovering the "Zoom out" action in the xy chart toolbar',
  }),
  zoomActionArrowUp: defineMessage({
    defaultMessage: 'Up',
    id: 'DHZv33G8z3rNPFeq',
    description:
      'Key shortcut in a tooltip shown when hovering the "Zoom in" action in the xy chart toolbar',
  }),
  zoomActionArrowDown: defineMessage({
    defaultMessage: 'Down',
    id: 'z5mvEP+L6qdzvis2',
    description:
      'Key shortcut in a tooltip shown when hovering the "Zoom out" action in xy chart toolbar',
  }),
  resetMode: defineMessage({
    id: 'zfKEZtJ/4td7IY+1',
    defaultMessage: 'Reset',
    description:
      'Text in a tooltip shown when hovering the "Reset" action in the xy chart toolbar',
  }),
};
